"use client";
import { useState, useEffect, Suspense } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { fetchUser } from '../funcs/api';
import MyShortLinks from '@/app/components/my-short-links/my-short-links';
import UserSettings from './_user_settings';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { loginUserGoogle, checkUserExists, updateUserPassword, loginUserGoogleAllInOne } from "@/app/funcs/auth";
import { toast } from 'react-toastify';
import { isLoggedIn } from '@/app/funcs/api'
import Sidebar from './_sidebar';
import './_sidebar.css';

// Separate component for search params logic
function AccountContent({ user, avatar, Logout }) {
    const searchParams = useSearchParams();
    const [activeSection, setActiveSection] = useState('');

    // Get the current section from URL search params
    useEffect(() => {
        const section = searchParams.get('section') || '';
        setActiveSection(section);
    }, [searchParams]);

    return (
        <div className="col-12 col-md-8 col-xl-9 pe-0">
            <UserSettings user={user} avatar={avatar} activeSection={activeSection ? activeSection : 'default'} />
        </div>
    );
}

export default function account() {
    const router = useRouter();
    const [user, setUser] = useState(null);
    const [avatar, setAvatar] = useState('');
    const [form, setForm] = useState({ name: '', description: '', email: '', password: '' });
    const [file, setFile] = useState(null);
    const [saving, setSaving] = useState(false);

    // 1. Redirect if not authenticated
    useEffect(() => {
        const token = localStorage.getItem('token');
        const sessionToken = isLoggedIn();
        console.log('session token');
        console.log(sessionToken);

        if (!isLoggedIn()) return router.push('/login')
        else {
            fetchUser().then(u => {
                setUser(u);
                console.log(u);
                // setForm({ name: u.name, description: u.description, email: u.email, password: '' });
            }).catch(() => router.push('/login'));
        }
    }, []);

    // set user avatar to local storage
    useEffect(() => {
        const localUser = localStorage.getItem('user');

        console.log('inside profile ');
        // Step 2: Parse it to an object
        let userObj = JSON.parse(localUser)
        // Step 3: Modify the object
        !userObj?.avatar && user?.avatar_id ? (userObj.avatar = user?.avatar_id?.sizes?.thumbnail) : null; // you can change the key and value
        // Step 4: Save it back
        localStorage.setItem('user', JSON.stringify(userObj))
    }, [user])

    useEffect(() => {
        user?.acf?.avatar_id?.sizes?.thumbnail ? setAvatar(user.acf.avatar_id?.sizes?.thumbnail) : null;
    }, [user]);

    const Logout = () => {
        sessionStorage?.removeItem('token');
        localStorage?.removeItem('user');
        localStorage?.removeItem('token');
        location.reload();
        // router.push('/');
    };

    // Google Account Linking
    const handleGoogleLink = async (credentialResponse) => {
        try {
            const googleToken = credentialResponse.credential;
            // console.log(token);
            const linkAccount = await loginUserGoogleAllInOne(googleToken);
            console.log(linkAccount);

            toast.success("تم ربط حساب Google بنجاح! يمكنك الآن تسجيل الدخول باستخدام Google One Tap.");

            // أول حاجة نحول الـ token من JSON string إلى object
            const parsedToken = JSON.parse(localStorage.getItem('user'));

            // بعدين نضيف عليه المفتاح الإضافي
            const userObject = {
                ...parsedToken,
                linked_with_google: linkAccount['linked_with_google']
            };

            // وبعدين نحفظه في localStorage
            localStorage.setItem('user', JSON.stringify(userObject));


            // const userInfo = token ? jwtDecode(token) : null;
            // if (!userInfo) throw new Error("Google token decode failed");

            // const { email, name, given_name, family_name } = userInfo;

            // // Check if the Google email matches the current user's email
            // if (email !== user?.email) {
            //     toast.error("البريد الإلكتروني في حساب Google لا يتطابق مع بريدك الإلكتروني الحالي");
            //     return;
            // }

            // // Validate Google token and user identity
            // try {
            //     // Verify the Google token is valid and belongs to the correct user
            //     if (userInfo.email === user.email && userInfo.email_verified) {
            //         // Successfully validated - this is the same user

            //         // Try to enable Google login by updating password
            //         try {
            //             const socialPassword = email + "_google_secret";
            //             // await updateUserPassword(user.id, socialPassword);



            //             toast.success("تم ربط حساب Google بنجاح! يمكنك الآن تسجيل الدخول باستخدام Google One Tap.");

            //             // Update user data in localStorage to mark as Google-linked
            //             const currentUser = JSON.parse(localStorage.getItem('user'));
            //             const updatedUser = { 
            //                 ...currentUser, 
            //                 google_linked: true,
            //                 google_email: email,
            //                 google_name: name || given_name
            //             };
            //             localStorage.setItem('user', JSON.stringify(updatedUser));

            //             // Optionally update the user state
            //             setUser(prev => ({
            //                 ...prev,
            //                 google_linked: true,
            //                 google_email: email,
            //                 google_name: name || given_name
            //             }));

            //         } catch (passwordUpdateErr) {
            //             // If password update fails, still mark as linked but warn user
            //             toast.success("تم ربط حساب Google! قد تحتاج لتسجيل الدخول بالطريقة العادية في المرة القادمة.");

            //             const currentUser = JSON.parse(localStorage.getItem('user'));
            //             const updatedUser = { 
            //                 ...currentUser, 
            //                 google_linked: true,
            //                 google_email: email,
            //                 google_name: name || given_name
            //             };
            //             localStorage.setItem('user', JSON.stringify(updatedUser));
            //         }

            //     } else {
            //         toast.error("فشل التحقق من هوية المستخدم");
            //     }

            // } catch (validationErr) {
            //     toast.error("فشل التحقق من حساب Google");
            //     console.error(validationErr);
            // }
        } catch (err) {
            toast.error("فشل ربط حساب Google: " + err.message);
            console.error(err);
        }
    };

    if (!user) return <div className='mx-auto my-5 bg-white text-center col-auto border rounded-4 py-3 px-4'>جار جلب البيانات ... <div className="spinner-border" role="status">
        <span className="sr-only"></span>
    </div></div>;

    return (
        <div className='mx-auto row'>
            {/* Sidebar Component */}
            <Sidebar
                user={user}
                avatar={avatar}
                Logout={Logout}
            />

            {/* Account content */}
            <Suspense fallback={<div className='mx-auto my-5 bg-white text-center col-auto border rounded-4 py-3 px-4'>جار جلب البيانات ... <div className="spinner-border" role="status">
                <span className="sr-only"></span>
            </div></div>}>
                <AccountContent user={user} avatar={avatar} Logout={Logout} />
            </Suspense>
        </div>
    );
}